import { z } from 'zod';
export const DEFAULT_BRAND_ACCENT = '#33363B';
export const BRAND_NAME_MAX_CHARS = 120;
export const LOGO_MAX_BYTES = 524_288;
export const LOGO_MIME_TYPES = ['image/png', 'image/jpeg', 'image/svg+xml'];
export const BrandUpdateSchema = z
    .object({
    displayName: z.string().trim().max(BRAND_NAME_MAX_CHARS),
    accent: z
        .string()
        .regex(/^#[0-9A-Fa-f]{6}$/)
        .nullable()
})
    .strict();
export function effectiveAccent(settings) {
    return settings.accent ?? DEFAULT_BRAND_ACCENT;
}
//# sourceMappingURL=brand.js.map